import { Checkbox } from "@/components/core/forms/checkbox";
import { CheckboxGroup } from "@/components/core/forms/checkbox-group";
import { Form } from "@/components/core/forms/form.tsx";
import { FormControl, FormDescription, FormField, FormGroup, FormItem, FormLabel, FormMessage } from "@/components/core/forms/form.tsx";
import { counselInfoQueryOptions } from "@/features/case-evaluation/api/queries/counsels-query";
import { useQuery } from "@tanstack/react-query";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { Blanket, BlanketInfo } from "./core/blanket";
import { Button } from "./core/buttons/button";
import { useModalControl } from "./core/modals/use-modal-controller";

export default function CounselInfoModal({
	rollNumber,
	onSubmit,
}: {
	onSubmit: (values: any) => void;
	rollNumber: string;
}) {
	const { data, refetch, isFetching } = useQuery(counselInfoQueryOptions(rollNumber));
	const counsel = data;

	const { closeModal } = useModalControl();
	const form = useForm({
		defaultValues: {
			id: 1,
		},
	});

	// Refetch when modal opens
	useEffect(() => {
		refetch();
	}, [refetch]);

	return (
		<Form {...form}>
			<form className="w-full">
				<div className="flex flex-col w-full col-span-12">
					<div className="flex flex-col w-full rounded-md border border-border/50 overflow-hidden">
						<div className="flex flex-col w-full">
							{isFetching ? (
								<Blanket width="sm">
									<BlanketInfo title="Loading Data" message="Fetching information for counsel. Please wait..." />
								</Blanket>
							) : (
								<table className="text-sm w-full">
									<tbody>
										<tr className="border-b last:border-b-0 border-border/50">
											<td className="w-[1%] whitespace-nowrap  bg-slate-50 font-semibold text-foreground-dark py-2 px-3">Roll Number</td>
											<td className="p-3 text-foreground py-2 px-3">{counsel?.RollNumber}</td>
										</tr>
										<tr className="border-b last:border-b-0 border-border/50">
											<td className="w-[1%] whitespace-nowrap  bg-slate-50 font-semibold text-foreground-dark py-2 px-3">Email</td>
											<td className="p-3 text-foreground py-2 px-3">{counsel?.Email}</td>
										</tr>
										<tr className="border-b last:border-b-0 border-border/50">
											<td className="w-[1%] whitespace-nowrap  bg-slate-50 font-semibold text-foreground-dark py-2 px-3">First Name</td>
											<td className="p-3 text-foreground py-2 px-3">{counsel?.Attorney_GivenName}</td>
										</tr>
										<tr className="border-b last:border-b-0 border-border/50">
											<td className="w-[1%] whitespace-nowrap  bg-slate-50 font-semibold text-foreground-dark py-2 px-3">Middle Name</td>
											<td className="p-3 text-foreground py-2 px-3">{counsel?.Attorney_MiddleInitial}</td>
										</tr>
										<tr className="border-b last:border-b-0 border-border/50">
											<td className="w-[1%] whitespace-nowrap  bg-slate-50 font-semibold text-foreground-dark py-2 px-3">Last Name</td>
											<td className="p-3 text-foreground py-2 px-3">{counsel?.Attorney_Surname}</td>
										</tr>
										<tr className="border-b last:border-b-0 border-border/50">
											<td className="w-[1%] whitespace-nowrap  bg-slate-50 font-semibold text-foreground-dark py-2 px-3">Suffix</td>
											<td className="p-3 text-foreground py-2 px-3">{counsel?.Attorney_Suffix}</td>
										</tr>
									</tbody>
								</table>
							)}
						</div>
					</div>
				</div>
				<div className="flex flex-row justify-between w-full gap-4 mt-4">
					<Button
						type="button"
						className=""
						variant="ghost"
						onClick={() => {
							closeModal();
						}}
					>
						Cancel
					</Button>

					<Button
						type="button"
						className=""
						variant="default"
						disabled={isFetching}
						onClick={() => {
							onSubmit(counsel);
							closeModal();
						}}
					>
						Add
					</Button>
				</div>
			</form>
		</Form>
	);
}
